export const home = {
  hero: {
    title: 'DR Group GmbH',
    subtitle: 'Investment holding and proprietary asset management',
    intro: 'We hold and manage investments in our own name and for our own account. We do not provide services to third parties.',
    viewStructure: 'View structure',
    contact: 'Contact'
  },
  tiles: {
    investments: {
      title: 'Investments',
      description: 'Strategic equity investments in our own name'
    },
    assetManagement: {
      title: 'Asset Management',
      description: 'Managing proprietary assets'
    },
    governance: {
      title: 'Governance',
      description: 'Clear structures and responsibilities'
    }
  }
};